var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpponentShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "178px",
    viewBox: "0 0 235 178",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platforma_ALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL---3.3---B\\u0142\\u0119dna",
    transform: "translate(-298.000000, -790.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(299.000000, 791.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#FFFFFF",
    points: "20.3444 175.714 55.6784 175.714 55.6784 79.381 20.3444 79.381"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-43",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    points: "20.3444 175.714 55.6784 175.714 55.6784 79.381 20.3444 79.381"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#FFFFFF",
    points: "55.6784 175.714 131.0114 175.714 131.0114 79.381 55.6784 79.381"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-45",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    points: "55.6784 175.714 131.0114 175.714 131.0114 79.381 55.6784 79.381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6787,25.6416 L43.6787,25.6416 L43.6787,79.3806 L159.6787,79.3806 C166.3057,79.3806 171.6787,67.3506 171.6787,52.5116 C171.6787,37.6716 166.3057,25.6416 159.6787,25.6416 Z",
    id: "Stroke-46",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#FFF6E7",
    points: "150.9784 175.714 180.5114 175.714 180.5114 103.81 150.9784 103.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-48",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    points: "150.9784 175.714 180.5114 175.714 180.5114 103.81 150.9784 103.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#FFF6E7",
    points: "88.0114 175.714 150.9784 175.714 150.9784 103.81 88.0114 103.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-50",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    points: "88.0114 175.714 150.9784 175.714 150.9784 103.81 88.0114 103.81"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.4912,
    y1: 1.0658141e-14,
    x2: 126.8652,
    y2: 38.374,
    id: "Stroke-51",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6787,52.5117 C55.6787,67.3507 50.3057,79.3807 43.6787,79.3807 C37.0507,79.3807 31.6787,67.3507 31.6787,52.5117 C31.6787,37.6717 37.0507,25.6417 43.6787,25.6417 C50.3057,25.6417 55.6787,37.6717 55.6787,52.5117",
    id: "Fill-52",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6787,52.5117 C55.6787,67.3507 50.3057,79.3807 43.6787,79.3807 C37.0507,79.3807 31.6787,67.3507 31.6787,52.5117 C31.6787,37.6717 37.0507,25.6417 43.6787,25.6417 C50.3057,25.6417 55.6787,37.6717 55.6787,52.5117 Z",
    id: "Stroke-53",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.39488462e-13,
    y1: 175.9589,
    x2: 232.542,
    y2: 175.9589,
    id: "Stroke-95",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpponentShapes);
export default __webpack_public_path__ + "static/media/opponentShapes.5269445e44f1c5308376736cd11ae1c2.svg";
export { ForwardRef as ReactComponent };